import { AccountDateRange, SortBy } from 'Types/account';
import { Order } from 'Types/generic';
import { PurchasesCompleteStatusTypes } from 'Types/purchaseCompleteStatus';

import type { BasicAccountFilterState, PurchasesCompleteFiltersState } from './AccountFiltersStore.types';

export const DEFAULT_BASIC_ACCOUNT_FILTERS_STATE: BasicAccountFilterState = {
	dateRangeType: AccountDateRange.ALL,
	keyword: undefined,
	order: Order.Descending,
	sortBy: SortBy.DATE_BID,
};

export const DEFAULT_PURCHASES_COMPLETE_FILTERS_STATE: PurchasesCompleteFiltersState = {
	...DEFAULT_BASIC_ACCOUNT_FILTERS_STATE,
	hideDelivered: false,
	purchasesCompleteStatusType: PurchasesCompleteStatusTypes.All,
	sortBy: SortBy.DATE_WON,
};
